import React from 'react';

const RecipeCard = ({ recipe }) => {
  const ingredients = [];

  for (let i = 1; i <= 20; i++) {
    const ingredient = recipe[`strIngredient${i}`];
    const measure = recipe[`strMeasure${i}`];
    if (ingredient && ingredient.trim() !== '') {
      ingredients.push(`${measure || ''} ${ingredient}`.trim());
    }
  }

  return (
    <div className="bg-white shadow-lg rounded-lg overflow-hidden transition-transform">
      <div className="relative">
        <img
          className="w-full h-48 object-cover object-center rounded-t-lg"
          src={recipe.strMealThumb}
          alt={recipe.strMeal}
        />
        <div className="absolute top-2 left-2 bg-indigo-500 text-white py-1 px-2 rounded">
          {recipe.strArea || 'Food'}
        </div>
      </div>
      <div className="p-4">
        <h1 className="text-2xl font-semibold text-gray-800 mb-2 capitalize">
          {recipe.strMeal}
        </h1>
        <div className="text-gray-600 mb-4">
          <span className="block mb-1">
            <b>Ingredients:</b>
          </span>
          {ingredients.map((ingredient, index) => (
            <span key={index} className="block pl-4">
              {ingredient}
            </span>
          ))}
        </div>
        <div className="flex items-center justify-between">
          <a
            href={recipe.strSource || recipe.strYoutube}
            target="_blank"
            rel="noopener noreferrer"
            className="text-indigo-500 font-semibold hover:underline"
          >
            View Recipe
          </a>
        </div>
      </div>
    </div>
  );
};

export default RecipeCard;
